export enum RouteParam {
  Guid = '{00015969-7fba-4442-a7a1-c13685f1783b}',
  Number = '{efcb17df-c152-4bf8-b9e6-7fff7df9e580}',
  Slug = '{d93359e8-8d9e-4ebf-9afa-c79eb3a52889}',
  Token = '{1450e3f4-84be-43ef-ba4e-266dcf528ce8}',
}
